import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type {
  GetAIChatHistoryRequest,
  GetAIChatHistoryResponse,
  GetAIFiltersRequest,
  GetAIFiltersResponse,
  SendAIChatMessageRequest,
  SendAIChatMessageResponse,
  StartAIChatRequest,
  StartAIChatResponse,
  VectorSearchRequest,
  VectorSearchResponse,
} from './dto';
import { AIFeaturesAPIRoutes } from './route';

export function fetchAIFilters(params: GetAIFiltersRequest): Promise<GetAIFiltersResponse> {
  return makeRequest(
    api.get(AIFeaturesAPIRoutes.getAIFilters(), {
      params: {
        ...params,
        warmUpLooker: 'true',
        permissions: JSON.stringify(params.permissions),
      },
    }),
  );
}

export function fetchVectorSearch(body: VectorSearchRequest): Promise<VectorSearchResponse> {
  return makeRequest(api.post(AIFeaturesAPIRoutes.vectorSearch(), body));
}

export function startAIChat({ workspaceId, ...body }: StartAIChatRequest): Promise<StartAIChatResponse> {
  return makeRequest(api.post(AIFeaturesAPIRoutes.startAIChat(workspaceId), body));
}

export function getAIChatHistory({ workspaceId, chatId }: GetAIChatHistoryRequest): Promise<GetAIChatHistoryResponse> {
  return makeRequest(api.get(AIFeaturesAPIRoutes.getAIChatHistory(workspaceId, chatId)));
}

export function sendAIChatMessage({
  workspaceId,
  chatId,
  ...body
}: SendAIChatMessageRequest): Promise<SendAIChatMessageResponse> {
  return makeRequest(api.post(AIFeaturesAPIRoutes.sendAIChatMessage(workspaceId, chatId), body));
}
